import { render, staticRenderFns } from "./page-worker-layout.vue?vue&type=template&id=29106661&"
import script from "./page-worker-layout.vue?vue&type=script&lang=js&"
export * from "./page-worker-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports